// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c8d98c3e","25":"759d0cbb","62":"46fec167","202":"d95a7cfe","221":"2cbd3a86","233":"50ea3798","267":"0141fd94","328":"8c0ec355","475":"10de5e1a","514":"83f304bf","517":"42ceeda1","741":"05cd5ddc"}[chunkId] + ".chunk.js";
};